// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3StoY","head":"Table_head__3-jbg","col":"Table_col__tFEPn"};